import FollowUpRule from './FollowUpRule';
import SurveyQuestion from './SurveyQuestion';
import SurveyQuestionType from './SurveyQuestionType';

class SurveyQuestionNumericSlider extends SurveyQuestion {
  min: number;

  max: number;

  constructor(
    questionId: string,
    questionType: SurveyQuestionType,
    title: string,
    description: string,
    group: string,
    variability: string,
    identifier: string,
    min: number,
    max: number,
    followUpRules: FollowUpRule[],
    imageIdentifier: string,
    info?: string,
    suffix?: string,
    allowSkipWithDefaultValue?: boolean
  ) {
    super(
      questionId,
      questionType,
      title,
      description,
      group,
      variability,
      identifier,
      followUpRules,
      imageIdentifier,
      info,
      suffix,
      allowSkipWithDefaultValue
    );

    this.min = min;
    this.max = max;
  }

  public static parse(object: any) {
    return new SurveyQuestionNumericSlider(
      object.QuestionId,
      object.QuestionType,
      object.Title,
      object.Description,
      object.Group,
      object.Variability,
      object.Identifier,
      object.Min,
      object.Max,
      object.FollowUpRules.map((rule: {}) => FollowUpRule.parse(rule)) ?? [],
      object.ImageIdentifier,
      object.Info ?? undefined,
      object.Suffix ?? undefined,
      object.AllowSkipWithDefaultValue ?? undefined
    );
  }
}

export default SurveyQuestionNumericSlider;
